import { GetSocketSessionIdFromCookies } from "@/helper/notificationHelper";
import { SetHeaderService } from "@/helper/userHelper";
import service from "../baseHttpService";
class NotificationService {
  DoGetUnseenNotificationCount(merchantId: number) {
    const headers: any = SetHeaderService().headers;
    const input = {
      notificationMerchantId: merchantId,
      socketSessionId: GetSocketSessionIdFromCookies(),
    }

    return service.peakExportAPI
      .post("/api/Notification/GetUnseenNotificationCount", input, headers)
      .then((res) => {
        return res;
      });
  }
  DoGetUnseenNotificationList(merchantId: number) {
    const headers: any = SetHeaderService().headers;
    const input = {
      notificationMerchantId: merchantId,
      socketSessionId: GetSocketSessionIdFromCookies(),
    }

    return service.peakExportAPI.post("/api/Notification/GetUnseenNotificationList", input, headers).then((res) => {
      return res;
    });
  }
  DoGetSeenNotificationList(merchantId: number) {
    const headers: any = SetHeaderService().headers;
    const input = {
      notificationMerchantId: merchantId,
      socketSessionId: GetSocketSessionIdFromCookies(),
    }

    return service.peakExportAPI.post("/api/Notification/GetSeenNotificationList", input, headers).then((res) => {
      return res;
    });
  }
  DoGetUnseenNotification(merchantId: number, notificationId: string) {
    const headers: any = SetHeaderService().headers;
    const input = {
      id: notificationId,
      notificationMerchantId: merchantId,
      socketSessionId: GetSocketSessionIdFromCookies(),
    };
    return service.peakExportAPI.post("/api/Notification/GetUnseenNotification", input, headers).then((res) => {
      return res;
    });
  }
  DoDeleteSeenNotification(merchantId: number, notificationId: string) {
    const headers: any = SetHeaderService();
    const input = {
      id: notificationId,
      notificationMerchantId: merchantId,
      socketSessionId: GetSocketSessionIdFromCookies(),
    };
    return service.peakExportAPI.post("/api/Notification/DeleteSeenNotification", input, headers).then((res) => {
      return res;
    });
  }
  DoDeleteUnseenNotification(merchantId: number, notificationId: string) {
    const headers: any = SetHeaderService();
    const input = {
      id: notificationId,
      notificationMerchantId: merchantId,
      socketSessionId: GetSocketSessionIdFromCookies(),
    };
    return service.peakExportAPI.post("/api/Notification/DeleteUnseenNotification", input, headers).then((res) => {
      return res;
    });
  }
  DoSetNotificationIsSeen(merchantId: number, notificationId: string) {
    const headers: any = SetHeaderService();
    const input = {
      id: notificationId,
      notificationMerchantId: merchantId,
      socketSessionId: GetSocketSessionIdFromCookies(),
    };
    return service.peakExportAPI.post("/api/Notification/SetNotificationIsSeen", input, headers).then((res) => {
      return res;
    });
  }
  DoSetAllNotificationIsSeen(merchantId: number) {
    const headers: any = SetHeaderService();
    const input = {
      notificationMerchantId: merchantId,
      socketSessionId: GetSocketSessionIdFromCookies(),
    }

    return service.peakExportAPI.post("/api/Notification/SetAllNotificationIsSeen", input, headers).then((res) => {
      return res;
    });
  }
}

export default new NotificationService();
